/**
 * Ekya Product Scroll — horizontal card row with arrow controls
 */
function initProductScroll(section) {
  const track = section.querySelector('[data-scroll-track]');
  const prev = section.querySelector('[data-scroll-prev]');
  const next = section.querySelector('[data-scroll-next]');
  if (!track) return;

  const scrollAmount = () => Math.max(track.clientWidth * 0.75, 280);

  const updateArrows = () => {
    const maxScroll = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= maxScroll;
  };

  prev?.addEventListener('click', () => {
    track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
  });

  next?.addEventListener('click', () => {
    track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);
  updateArrows();
}

document.querySelectorAll('.ekya-product-scroll').forEach(initProductScroll);

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.closest?.('.ekya-product-scroll-section') || event.target;
  const section = root.querySelector?.('.ekya-product-scroll') || root.closest?.('.ekya-product-scroll');
  if (section) initProductScroll(section);
});
